function useReport() {
    const test = "ggggg"
    return {
        test
    }
}
export default useReport;